

import { makeStyles } from 'tss-react/mui';
import React from 'react';
import { Box, Grid, KeyValue } from 'web-library';
import { useTranslation } from 'react-i18next';
import FormHeader from './form-items/FormHeader';

const useStyles = makeStyles()((theme) =>
({
  container: {
    paddingBottom: theme.spacing(2),
    maxWidth: 960,
  },
}));

export interface PersonalDetailsProps {
  horizontalRule?: boolean;
  statutoryName?: string;
  hanyuPinyinName?: string;
  nricFin?: string;
  nationality?: string;
  citizenship?: string;
  schoolName?: string;
}

const PersonalDetails = ({
  horizontalRule,
  statutoryName = '',
  hanyuPinyinName = '',
  nricFin = '',
  nationality = '',
  citizenship = '',
  schoolName = '',
}: PersonalDetailsProps) => {
  const { classes } = useStyles();
  const { t } = useTranslation();

  return (
    <Box className={classes.container}>
      <FormHeader title={t('components->>PersonalDetails.Personal Particulars')} />

      <KeyValue
        id="candidateName"
        keyText={t('components->>PersonalDetails.Candidate Name')}
        valueText={statutoryName}
      />

      <Grid container direction="row">
        <Grid md={6} sm={12}>
          <KeyValue
            id="hanyuPinyinName"
            keyText={t('components->>PersonalDetails.Hanyu Pinyin Name')}
            valueText={hanyuPinyinName}
          />
        </Grid>
      </Grid>

      <KeyValue
        id="nricFinPassport"
        keyText={t('components->>PersonalDetails.NRIC/FIN/Passport No.')}
        valueText={nricFin}
      />

      <Grid container direction="row">
        <Grid md={6} sm={12} xs={12}>
          <KeyValue
            id="citizenship"
            keyText={t('components->>PersonalDetails.Citizenship')}
            valueText={citizenship}
          />
        </Grid>
        <Grid md={6} sm={12} xs={12}>
          <KeyValue
            id="nationality"
            keyText={t('components->>PersonalDetails.Nationality')}
            valueText={nationality}
          />
        </Grid>
      </Grid>

      <KeyValue
        id="school"
        keyText={t('components->>PersonalDetails.School')}
        valueText={schoolName}
      />
    </Box>
  );
};

export default PersonalDetails;
